// Module
var code = `<div class="form-section">
  <h2 class="section-header">Application data</h2>
  <div class="form-column">
    <form-section-field ng-if="\$ctrl.application.code" field-title="'Agent code'">
      <input type="text" disabled ng-model="\$ctrl.application.code" />
    </form-section-field>

    <form-section-field field-title="'BRD Report ID'">
      <input type="text"
             class="section__select"
             ng-disabled="!\$ctrl.editMode"
             ng-model="\$ctrl.application.brdReportId"
             maxlength="512">
    </form-section-field>

    <form-section-field field-title="'Agent branch'">
      <select
        required
        class="section__select"
        ng-disabled="!\$ctrl.editMode"
        ng-model="\$ctrl.application.branchId"
        ng-options="branch.id as branch.name for branch in \$ctrl.branches">
      </select>
    </form-section-field>

    <form-section-field field-title="'Agent CIF'"
         ng-if="\$ctrl.application.customerId">
      <input type="text" disabled ng-model="\$ctrl.application.customer.customerNumber" />
    </form-section-field>

    <form-section-field field-title="'Status'"
         ng-if="\$ctrl.application.id">
      <select
        class="section__select"
        required
        ng-disabled="!\$ctrl.editStatus"
        ng-model="\$ctrl.application.status"
        ng-options="s | prettyEnum for s in \$ctrl.applicationStatuses">
      </select>
    </form-section-field>
  </div>

  <div class="clearfix"></div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/candidacy/agent-candidacy-header.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;